import React from 'react';
import styles from './Step.module.css';

export default props => {
  const { step, status, customThemeBaseColor } = props;

  const getStepClassName = () => {
    if (status === 'active') {
      return {
        step: `${styles.coloredCircles} ${styles.active}`,
        label: styles.label,
        innerCircleStyle: {
          backgroundColor: customThemeBaseColor
            ? `${customThemeBaseColor}50`
            : '#a184f1'
        },
        outerCircleStyle: { backgroundColor: customThemeBaseColor || '#4926e9' }
      };
    }
    if (status === 'completed') {
      return {
        step: `${styles.coloredCircles} ${styles.completed}`,
        innerCircleStyle: {
          backgroundColor: customThemeBaseColor
            ? `${customThemeBaseColor}50`
            : '#a184f1'
        },
        outerCircleStyle: { backgroundColor: customThemeBaseColor || '#4926e9' }
      };
    }
    return {
      step: styles.coloredCircles,
      innerCircleStyle: {
        backgroundColor: customThemeBaseColor
          ? `${customThemeBaseColor}50`
          : '#e2dafa'
      },
      outerCircleStyle: { backgroundColor: customThemeBaseColor || '#c8bdf8' }
    };
  };

  return (
    <div className={styles.stepContainer}>
      <div className={styles.stepContainerOuterCircle}>
        <div className={getStepClassName().step}>
          <div
            className={styles.outerCircle}
            style={getStepClassName().innerCircleStyle}
          />
          <div
            className={styles.stepContainerInnerCircle}
            style={getStepClassName().outerCircleStyle}
          />
        </div>
      </div>
      {getStepClassName().label && (
        <div
          className={getStepClassName().label}
          style={{ color: customThemeBaseColor || '#4926e9' }}
        >
          {step}
        </div>
      )}
    </div>
  );
};
